import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostUser from 'flarum/forum/components/PostUser';
import Link from 'flarum/common/components/Link';
export default function addPrimaryBadgeToPost() {
  extend(PostUser.prototype, 'view', function (vnode) {
    const post = this.attrs.post;
    const user = post.user();
    if (!user) return;
    const displayMode = app.forum.attribute('primaryBadgeDisplay');
    if (displayMode === 'hidden') return;
    const badgeName = user.attribute('primaryBadgeName');
    const badgeIcon = user.attribute('primaryBadgeIcon');
    if (!badgeName || !badgeIcon) return;
    if (vnode && vnode.children && Array.isArray(vnode.children)) {
      const badgeElement = m(Link, {
        href: app.route('user.badges', {
          username: user.slug()
        }),
        className: "PrimaryBadge",
        title: badgeName
      }, m("i", {
        className: badgeIcon
      }), displayMode === 'icon_name' && m("span", {
        className: "PrimaryBadge-name"
      }, badgeName));
      vnode.children.push(badgeElement);
    }
  });
}